import { useParams } from 'react-router-dom'
import { useGetRouteTypes } from '@/lib/react-query'
import { useMemo } from 'react'
import { toastSuccess } from '@/utils/toast'
import { CodeEditorConfig } from '@/types'
import { useButtonNavigateClick } from '@/hooks/useButtonNavigateClick'
import { RouteTemplate, useUpdateRouteTemplate } from '@/features/templates'

export type UseSaveRouteTemplateArgs = {
  template: RouteTemplate
  name: string
  code: string
  onSuccess?: () => void
}

export const usePageParams = () => {
  const { templateId } = useParams()

  return {
    templateId: parseInt(templateId!),
  }
}

export const useTemplateRouteEditorConfig = (template: RouteTemplate): CodeEditorConfig => {
  const language = ['python3', 'python3_10'].includes(template.runtime) ? 'python' : 'typescript'
  const { data: routeTypes } = useGetRouteTypes(template.type)

  return useMemo(
    () => ({
      connectors: [],
      language,
      types: routeTypes!.types,
    }),
    [language, routeTypes!.types]
  )
}

export const useSaveRouteTemplate = ({ template, code, name, onSuccess }: UseSaveRouteTemplateArgs) => {
  const mutation = useUpdateRouteTemplate(template.id!)

  const save = async () => {
    await mutation.mutateAsync({ template: { name, requirements: template.requirements }, code })
    toastSuccess(`Route ${name} saved`, 'Now you can close tab')

    onSuccess?.()
  }

  return [mutation.isPending, save] as const
}

export const useGoBack = () => {
  return useButtonNavigateClick('/templates/routes')
}
